function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12pt",
    height: "12pt",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,36.470588%,75.686275%)",
      fillOpacity: 1
    },
    d: "M 11.039062 1.445312 L 4.402344 1.445312 L 4.402344 11.570312 L 11.039062 11.570312 Z M 11.039062 1.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 7.117188 0.320312 L 0.480469 0.320312 L 0.480469 11.582031 L 7.117188 11.582031 Z M 7.117188 0.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 3.371094 1.667969 L 1.796875 1.667969 L 1.796875 3.402344 L 3.371094 3.402344 Z M 3.371094 1.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 5.722656 1.667969 L 4.148438 1.667969 L 4.148438 3.402344 L 5.722656 3.402344 Z M 5.722656 1.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 3.371094 4.40625 L 1.796875 4.40625 L 1.796875 6.136719 L 3.371094 6.136719 Z M 3.371094 4.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 5.722656 4.40625 L 4.148438 4.40625 L 4.148438 6.136719 L 5.722656 6.136719 Z M 5.722656 4.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 3.371094 7.125 L 1.796875 7.125 L 1.796875 8.859375 L 3.371094 8.859375 Z M 3.371094 7.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(67.843137%,77.254902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 5.722656 7.125 L 4.148438 7.125 L 4.148438 8.859375 L 5.722656 8.859375 Z M 5.722656 7.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 7.835938 3.101562 L 6.261719 3.101562 L 6.261719 4.835938 L 7.835938 4.835938 Z M 7.835938 3.101562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 10.1875 3.101562 L 8.617188 3.101562 L 8.617188 4.835938 L 10.1875 4.835938 Z M 10.1875 3.101562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 7.835938 5.835938 L 6.261719 5.835938 L 6.261719 7.570312 L 7.835938 7.570312 Z M 7.835938 5.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 10.1875 5.835938 L 8.617188 5.835938 L 8.617188 7.570312 L 10.1875 7.570312 Z M 10.1875 5.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 7.835938 8.554688 L 6.261719 8.554688 L 6.261719 10.289062 L 7.835938 10.289062 Z M 7.835938 8.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,55.294118%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 10.1875 8.554688 L 8.617188 8.554688 L 8.617188 10.289062 L 10.1875 10.289062 Z M 10.1875 8.554688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.ef7447be726784a43d20eb2e897b89d0.svg";
export { ForwardRef as ReactComponent };